export const changeIsSuperAdminReducer = (state = false, action) => {
  switch (action.type) {
    case "CHANGE_IS_SUPER_ADMIN":
      return action.payload.isSuperAdmin;
    default:
      return state;
  }
};
